import DetailSetUpReverseProxy from "../../../../contents/docs/integrate/_snippets/details/set-up-reverse-proxy.mdx";
import DetailGroupProductsInOneProject from "../../../../contents/docs/integrate/_snippets/details/group-products-in-one-project.mdx";
import DetailPostHogIPs from "../../../../contents/docs/integrate/_snippets/details/posthog-ips.mdx";
import ReactNativeInstall from "../../../../contents/docs/integrate/_snippets/install-react-native.mdx";
import RNSendEvents from "../../../../contents/docs/integrate/send-events/_snippets/send-events-react-native.mdx";
import AutocaptureConfigs from "../../../../contents/docs/libraries/react-native/_snippets/autocapture-config-rn.mdx";
import ReactNativeIdentify from "../../../../contents/docs/libraries/react-native/_snippets/identify.mdx";
import FeatureFlagsLibsIntro from "../../../../contents/docs/libraries/_snippets/feature-flags-libs-intro.mdx";
import ReactNativeFeatureFlagsCode from "../../../../contents/docs/integrate/feature-flags-code/_snippets/feature-flags-code-react-native.mdx";
import BootstrappingIntro from "../../../../contents/docs/feature-flags/snippets/bootstrapping-intro.mdx";
import * as React from 'react';
export default {
  DetailSetUpReverseProxy,
  DetailGroupProductsInOneProject,
  DetailPostHogIPs,
  ReactNativeInstall,
  RNSendEvents,
  AutocaptureConfigs,
  ReactNativeIdentify,
  FeatureFlagsLibsIntro,
  ReactNativeFeatureFlagsCode,
  BootstrappingIntro,
  React
};